// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table .danger-cell{color:#f56c6c}.el-table .sign_cell div{white-space:pre-line}", ""]);
// Exports
module.exports = exports;
